import { useCallback } from "react";
import { putSignatures } from "../api/chains";
import { useChainStore } from "../store/chainStore";
import type { Signature } from "../types/chain";

export interface SignatureSaver {
  save: (
    systemId: string,
    signatures: Signature[],
    lazyDelete?: boolean,
  ) => Promise<void>;
  setWhType: (
    systemId: string,
    scanId: string,
    whType: string | null,
  ) => Promise<void>;
}

export function useSignatureSaver(): SignatureSaver {
  const replaceSignatures = useChainStore((s) => s.replaceSignatures);
  const save = useCallback(
    async (
      systemId: string,
      signatures: Signature[],
      lazyDelete: boolean = true,
    ) => {
      const chainId = useChainStore.getState().chainId;
      if (chainId == null) return;
      const saved = await putSignatures(chainId, systemId, signatures, lazyDelete);
      replaceSignatures(systemId, saved);
    },
    [replaceSignatures],
  );
  const setWhType = useCallback(
    async (systemId: string, scanId: string, whType: string | null) => {
      const system = useChainStore
        .getState()
        .systems.find((s) => s.id === systemId);
      if (!system) return;
      const next = system.signatures.map((sig) =>
        sig.scan_id === scanId ? { ...sig, wh_type: whType } : sig,
      );
      await save(systemId, next);
    },
    [save],
  );
  return { save, setWhType };
}
